import { SingletonScriptManager } from '@tencent/eco-fe-toolkit-utils';
import { isiOS } from './helpers';
import { ENV, MSDK_ADAPTER_URLS, WECHAT_APPID_MAP, WECHAT_TYPE_MAP } from './helpers/constants';

export default class MSDKV3Adapter {
  constructor() {
    this.init();
  }

  async init() {
    if (
      typeof window.msdkShare !== 'function'
      || typeof window.msdkiOSHandler !== 'function'
    ) {
      // await getScript('//obd.gtimg.com/assets/js/msdkJsAdapter.js');
      await SingletonScriptManager.getInstance().load({
        src: MSDK_ADAPTER_URLS.OFFICAL,
        key: SingletonScriptManager.ScriptKeyPreset.MsdkJsAdapter,
      });
    }
  }

  async openWechatMiniProgram(params) {
    try {
      const { appName, path, query, type } = params;
      await this.init();
      const WXShareLaunchMiniApp = {
        MsdkMethod: 'WGLaunchMiniApp',
        userName: WECHAT_APPID_MAP.get(appName),
        page: '',
        path: `${path}?${query}&env=${type}`,
        type: WECHAT_TYPE_MAP.get(type || ENV.RELEASE),
      };
      window.msdkShare(JSON.stringify(WXShareLaunchMiniApp));
      return {
        code: 0,
        type: 'v3',
      };
    } catch (e) {
      return {
        msg: e.toString(),
        code: -1,
        type: 'v3',
      };
    }
  }

  // @deprecated
  // android端部分手游会报错
  isWechatInstalled() {
    const schema = isiOS() ? 'weixin://' : 'com.tencent.mm';
    return new Promise((resolve) => {
      if (isiOS()) {
        const params = `{"packageUrl":"${schema}"}`;
        window.msdkiOSHandler('isAppInstalled', params, resolve);
      } else {
        const params = `{"MsdkMethod":"isAppInstalled","package":"${schema}"}`;
        resolve(prompt(params));
      }
    }).catch(() => 'true');
  }
}
